import { render, staticRenderFns } from "./MDrecommendations.vue?vue&type=template&id=db97bcf8"
import script from "./MDrecommendations.vue?vue&type=script&lang=js"
export * from "./MDrecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports